"use client";

import React, { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
const navLinks = [{
  label: "Profil",
  href: "#profil"
}, {
  label: "Komando",
  href: "#komando"
}, {
  label: "Wilayah",
  href: "#wilayah"
}, {
  label: "Unit",
  href: "#unit"
}, {
  label: "Kegiatan",
  href: "#kegiatan"
}, {
  label: "Layanan",
  href: "#layanan"
}];
export default function StickyInternalNavigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeLink, setActiveLink] = useState("#profil");
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="sticky-internal-navigation" className={`sticky top-0 z-40 w-full border-b border-[#F2F2F2] transition-colors duration-300 ${isScrolled ? "bg-background/90 backdrop-blur-md" : "bg-background"}`}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-12 sm:h-14 lg:h-[60px] items-center">
          <nav className="flex h-full w-full gap-4 sm:gap-6 lg:gap-8 overflow-x-auto sm:overflow-x-visible [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]" aria-label="Secondary Navigation">
            {navLinks.map((link, i) => <Link key={link.label} to={link.href} data-index={i} onClick={() => setActiveLink(link.href)} className={`flex h-full shrink-0 items-center border-b-[3px] px-1 text-xs sm:text-sm lg:text-base font-semibold uppercase tracking-wider transition-colors duration-200 ${activeLink === link.href ? "border-primary text-foreground" : "border-transparent text-muted-foreground hover:border-primary hover:text-foreground"}`}>
                {link.label}
              </Link>)}
          </nav>
        </div>
      </div>
    </section>;
}